var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-container"},[_c('img',{staticClass:"icon",attrs:{"src":("" + _vm.assetPath + _vm.iconName)}})])}
var staticRenderFns = []

export { render, staticRenderFns }